// This file is auto-generated by @hey-api/openapi-ts

/**
 * Method used for employee counter authentication.
 */
export const CounterAuthenticationMethodsEnum = { USERNAME_PASSWORD: 'USERNAME_PASSWORD', ACTIVE_DIRECTORY: 'ACTIVE_DIRECTORY' } as const;

/**
 * Method used for employee counter authentication.
 */
export type CounterAuthenticationMethodsEnum = typeof CounterAuthenticationMethodsEnum[keyof typeof CounterAuthenticationMethodsEnum];
